/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid, Card, CardContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import styled from "styled-components";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import { SERVICES } from "../../../../components/Layout/Services/MasterDataServices";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import Styles from "./PersonalDetails.styles";

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

// Styled Card Component
const StyledCard = styled(Card)`
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
  height: 100%;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  }
`;

function PersonalDetailsSearch({
  clearValues,
  onDetailsChange,
  setPersonalDetailsValues,
}) {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onDetailsChange((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const [memberId, setMemberId] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [subDivisionVal, setSubDivisionVal] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [subDivisionName, setSubDivisionName] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const handleStates = async () => {
    try {
      const url = `${SERVICES.GET_STATES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setStates(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleCities = async () => {
    try {
      if (stateVal !== "") {
        const url = `${SERVICES.GET_STATES}/${stateVal}/cities`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setCities(data.data);
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleDivisions = async () => {
    try {
      const url = `${SERVICES.GET_DIVISIONS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setDivisions(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleStateChange = (selectedValue) => {
    setStateVal(selectedValue?.value);
    setStateName(selectedValue?.stateName);
    onDetailsChange((prevValues) => ({
      ...prevValues,
      stateId: selectedValue?.value,
    }));
  };

  const handleCityChange = (selectedValue) => {
    setCityVal(selectedValue?.value);
    setCityName(selectedValue?.cityName);
    onDetailsChange((prevValues) => ({
      ...prevValues,
      cityId: selectedValue?.value,
    }));
  };

  const handleDivisionChange = (selectedValue) => {
    setDivisionVal(selectedValue?.value);
    setDivisionName(selectedValue?.shortName);
    onDetailsChange((prevValues) => ({
      ...prevValues,
      divisionId: selectedValue?.value,
    }));
  };

  const handleSubDivisionChange = (selectedValue) => {
    setSubDivisionVal(selectedValue?.value);
    setSubDivisionName(selectedValue?.shortName);
    onDetailsChange((prevValues) => ({
      ...prevValues,
      subdivisionId: selectedValue?.value,
    }));
  };

  useEffect(() => {
    handleStates();
    handleCities();
    handleDivisions();
  }, [stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal),
        )?.subDivisions ?? [];
      setSubDivisions(newSubDivisions);
    }
  }, [divisionVal]);

  useEffect(() => {
    setPersonalDetailsValues((prevValues) => ({
      ...prevValues,
      id: memberId || "",
      fullName: fullName || "",
      mobileNumber: phoneNumber || "",
      emailId: email || "",
      address: address || "",
      pincode: pinCode || "",
      stateName: stateName || "",
      cityName: cityName || "",
      divisionName: divisionName || "",
      subDivisionName: subDivisionName || "",
    }));
  }, [
    memberId,
    fullName,
    phoneNumber,
    email,
    address,
    pinCode,
    stateName,
    cityName,
    divisionName,
    subDivisionName,
  ]);

  useEffect(() => {
    if (clearValues) {
      setMemberId("");
      setFullName("");
      setPhoneNumber("");
      setEmail("");
      setAddress("");
      setPinCode("");
      setStateVal("");
      setCityVal("");
      setDivisionVal("");
      setSubDivisionVal("");
      setStateName("");
    }
  }, [clearValues]);

  useEffect(() => {
    if (queryParams.get("memberId") === null) {
      setMemberId("");
    }
    if (queryParams.get("fullName") === null) {
      setFullName("");
    }
    if (queryParams.get("mobileNumber") === null) {
      setPhoneNumber("");
    }
    if (queryParams.get("emailId") === null) {
      setEmail("");
    }
    if (queryParams.get("address") === null) {
      setAddress("");
    }
    if (queryParams.get("pincode") === null) {
      setPinCode("");
    }
    if (queryParams.get("stateId") === null) {
      setStateVal("");
    }
    if (queryParams.get("cityId") === null) {
      setCityVal("");
    }
    if (queryParams.get("divisionId") === null) {
      setDivisionVal("");
    }
    if (queryParams.get("subdivisionId") === null) {
      setSubDivisionVal("");
    }
  }, [
    queryParams.get("fullName"),
    queryParams.get("memberId"),
    queryParams.get("mobileNumber"),
    queryParams.get("emailId"),
    queryParams.get("address"),
    queryParams.get("pincode"),
    queryParams.get("stateId"),
    queryParams.get("cityId"),
    queryParams.get("divisionId"),
    queryParams.get("subdivisionId"),
  ]);

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Card 1: Member Details (Member ID, Member Name) */}
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <StyledCard>
            <CardContent sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputField
                    label="Member Id"
                    name="id"
                    style={Styles.textfieldStyle}
                    value={memberId}
                    onChange={(event) => {
                      const { value } = event.target;
                      setMemberId(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputField
                    label="Member Name"
                    name="fullName"
                    style={Styles.textfieldStyle}
                    value={fullName}
                    onChange={(event) => {
                      const { value } = event.target;
                      setFullName(value);
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>

        {/* Card 2: Contact Details (Phone Number, Email ID) */}
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <StyledCard>
            <CardContent sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputField
                    label="Phone Number"
                    name="mobileNumber"
                    type="text"
                    style={Styles.textfieldStyle}
                    inputProps={{
                      maxLength: 10,
                    }}
                    value={phoneNumber}
                    onChange={(event) => {
                      const { value } = event.target;
                      setPhoneNumber(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputField
                    label="Email Id"
                    name="emailId"
                    style={Styles.textfieldStyle}
                    type="email"
                    value={email}
                    onChange={(event) => {
                      const { value } = event.target;
                      setEmail(value);
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>

        {/* Card 3: Address Details (Address, Pincode, State, City) */}
        {/* <Grid item lg={3} md={6} sm={6} xs={12}>
          <StyledCard>
            <CardContent sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputField
                    label="Address"
                    name="address"
                    style={Styles.textfieldStyle}
                    value={address}
                    onChange={(event) => {
                      const { value } = event.target;
                      setAddress(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputField
                    label="Pincode"
                    type="text"
                    name="pincode"
                    style={Styles.textfieldStyle}
                    inputProps={{
                      maxLength: 6,
                    }}
                    value={pinCode}
                    onChange={(event) => {
                      const { value } = event.target;
                      setPinCode(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.stateName}
                    label="State"
                    name="stateId"
                    options={getOptions(states, "stateId")}
                    value={stateVal}
                    style={Styles.dropdownfieldStyle}
                    inputProps={{ required: false }}
                    onChange={handleStateChange}
                    useHiddenInput
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.cityName}
                    label="City"
                    name="cityId"
                    options={getOptions(cities, "cityId")}
                    value={cityVal}
                    style={Styles.dropdownfieldStyle}
                    inputProps={{ required: false }}
                    onChange={handleCityChange}
                    useHiddenInput
                  />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid> */}

        {/* Card 4: Division Details (Division, Sub Division) */}
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <StyledCard>
            <CardContent sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.shortName}
                    label="Division"
                    name="divisionId"
                    options={getOptions(divisions, "divisionId")}
                    value={divisionVal}
                    style={Styles.dropdownfieldStyle}
                    inputProps={{ required: false }}
                    onChange={handleDivisionChange}
                    useHiddenInput
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.shortName}
                    label="Sub Division"
                    name="subdivisionId"
                    options={getOptions(subDivisions, "divisionId")}
                    value={subDivisionVal}
                    style={Styles.dropdownfieldStyle}
                    disabled={!divisionVal}
                    onChange={handleSubDivisionChange}
                    useHiddenInput
                  />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalDetailsSearch;
